import React from 'react';
import styles from './ProgressNav.module.css';

type Props = {
  number: string,
  item: any,
  selected: boolean,
};
function ProgressNavNode({ number, item, selected }:Props) {
  return (
    <div
      className={`${styles.node} ${selected ? styles.selected : ''}`}
      data-testid={`${item.title}${selected ? '-selected' : ''}`}
    >
      <div className={styles.circle}>{number}</div>
      <div className={styles.title}>{item.title}</div>
    </div>
  );
}

export default ProgressNavNode;
